import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const MaskedLine = ({ children, delay = 0, inView = false, className = "" }) => {
  const anim = { y: "0%" };
  const initial = { y: "115%" };
  const transition = { duration: 1.1, delay, ease: [0.16, 1, 0.3, 1] };
  return (
    <span className={`block overflow-hidden ${className}`}>
      {inView ? (
        <motion.span
          className="block will-change-transform"
          initial={initial}
          whileInView={anim}
          viewport={{ once: true, margin: "-10% 0px" }}
          transition={transition}
        >
          {children}
        </motion.span>
      ) : (
        <motion.span
          className="block will-change-transform"
          initial={initial}
          animate={anim}
          transition={transition}
        >
          {children}
        </motion.span>
      )}
    </span>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", y = 30, ...rest }) => (
  <motion.div
    {...rest}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8% 0px" }}
    transition={{ duration: 0.8, delay, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

export const ParallaxImage = ({ src, alt, className = "", imgClassName = "", speed = 0.12 }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [`-${speed * 100}%`, `${speed * 100}%`]);
  return (
    <div ref={ref} className={`overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        style={{ y }}
        className={`h-full w-full scale-[1.25] object-cover ${imgClassName}`}
      />
    </div>
  );
};
